import { Injectable } from '@angular/core';
import { ChartDraftEdit, ChartDraftEditProvider } from 'src/app/models/chart-draft.model';

/**
 * In-memory registry of the editable chart surfaces currently active.
 *
 * Kept dependency-free on purpose so both the chart-draft coordinator and the patient timer can
 * consult it without creating a circular dependency.
 */
@Injectable({
  providedIn: 'root',
})
export class ChartEditRegistryService {
  private providers: ChartDraftEditProvider[] = [];

  register(provider: ChartDraftEditProvider): void {
    if (!this.providers.includes(provider)) {
      this.providers.push(provider);
    }
  }

  unregister(provider: ChartDraftEditProvider): void {
    this.providers = this.providers.filter((p) => p !== provider);
  }

  /** Snapshot of the top-most (most recently registered) dirty surface, if any. */
  getActiveEdit(): ChartDraftEdit | null {
    for (let i = this.providers.length - 1; i >= 0; i--) {
      const snapshot = this.providers[i].snapshot();
      if (snapshot) {
        return snapshot;
      }
    }
    return null;
  }

  findProvider(type: ChartDraftEdit['type']): ChartDraftEditProvider | undefined {
    return this.providers.find((provider) => provider.editType === type);
  }
}
